import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalHeader, ModalFooter, Button } from '@doxyme/ui';
import './confirm-leave-modal.scss';
export const ConfirmLeaveModal = ({ onClose = () => { }, onLeave = () => { }, }) => {
    // prevents Modal component from leaving body's overflow 'hidden'
    useEffect(() => {
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);
    return (<Modal ariaLabelledby="video-chat-confirm-leave-modal" className="video-chat-confirm-leave-modal" isOpen isSmall closeModal={onClose}>
      <ModalHeader onClose={onClose}>
        <h4>
          <FormattedMessage id="video-chat.confirm-modal.title"/>
        </h4>
      </ModalHeader>
      <ModalFooter>
        <div className="ui-modal-actions">
          <Button size="medium" btnStyle="outline" color="secondary" onClick={onLeave}>
            <FormattedMessage id="video-chat.confirm-modal.leave"/>
          </Button>
          <Button size="medium" onClick={onClose}>
            <FormattedMessage id="video-chat.confirm-modal.continue"/>
          </Button>
        </div>
      </ModalFooter>
    </Modal>);
};
